module.exports = __webpack_public_path__ + "img/tooth.8d038d2d.png";